var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditLabelSetting',{attrs:{"title":"Edit Button Text","modelKey":("public_advance_setting." + _vm.modelKey),"defaultValue":_vm.defaultValue,"classList":_vm.classList,"tagName":"button","disabled":_vm.disabled,"additionalFields":_vm.convertedAdditionalFields},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f05f7d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/EditButtonSetting.vue
// module id = 887
// module chunks = 38